import { z } from 'zod'
import { guideLevelSettingsSchema, versionLevelSettingsSchema } from './shared'
import {
	ParsedPageWithContent,
	ParsedSidebarItemConfigWithPageContent,
	sidebarSchema,
} from './sidebar'

export const guideVersionSchema = z.object({
	sidebar: sidebarSchema,
	settings: versionLevelSettingsSchema,
	/**
	 * Pages that are not shown in the sidebar.
	 */
	// hiddenPages
})

// Guide Schema
export const guideSchema = z.object({
	variant: z.literal('GUIDE'),
	settings: guideLevelSettingsSchema,
})

export const guideVersionWithPathSchema = guideVersionSchema.extend({
	path: z.string(),
})

export const guideSchemaWithVersionsAndPath = guideSchema.extend({
	versions: z.array(guideVersionWithPathSchema),
	path: z.string(),
})

export type ParsedGuideVersionWithPathConfig = Omit<
	z.infer<typeof guideVersionWithPathSchema>,
	'sidebar'
> & {
	sidebar: ParsedSidebarItemConfigWithPageContent[]
	hiddenPages: ParsedPageWithContent[]
}
export type ParsedGuideVersionConfig = z.infer<typeof guideVersionSchema>

export type ParsedGuideConfig = z.infer<typeof guideSchema>
export type ParsedGuideWithVersionsConfig = Omit<
	z.infer<typeof guideSchemaWithVersionsAndPath>,
	'versions'
> & {
	versions: ParsedGuideVersionWithPathConfig[]
}
